import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const TemplateGroupWrapper = styled.div``;

export const TemplateGroupTitle = styled.div`
  display: block;
  font-size: 21px;
  margin: 0 0 16px 0;
  color: ${COLOR.BLACK};
  ${TYPOGRAPHY.BOLD}
`;

export const InfoIcon = styled(FontAwesomeIcon)`
  width: 12px;
  height: 12px;
  color: ${COLOR.WHITE};
  margin-left: 4px;
  position: relative;
  top: 1px;
`;

export const TemplateGroupContainer = styled(FlexContainer)``;
